import React from "react";
import { getData } from "app/data";
import Hero from "./Hero";
import CommonUseCases from "components/CommonUseCases";
import WaitingFor from "components/Banner/WaitingFor";
import GreenBanner from "components/Banner/GreenBanner";
import ContentsTwoColumn from "components/SoftwareSolution/ContentsTwoColumn";
import HeaderBackground from "components/BackGround/HeaderBackground";
import { ReactComponent as LeftBox } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";
import BenefitsCard from "./BenefitsCard";
import classes from "./Kiosk.module.css";
import { useSmoothScroll } from 'components/Main/pages/MerchantService/useSmoothScroll.js';

const KioskSoftwareSolution = () => {
  const heroData = getData("kioskData")[0];
  const kioskData = getData("kioskData")[1];
  const { myRef, clickHandle } = useSmoothScroll();

  return (
    <div className={classes["kiosk-root"]}>
      <HeaderBackground />
      <Hero data={heroData} header={true} clickHandle={clickHandle} />
      <div className={classes.background}>
        <LeftBox className={classes["left-box-bg"]} />
        <RightBox className={classes["right-box-bg"]} />
        <LeftBox className={classes["left2-box-bg"]} />
        <RightBox className={classes["right2-box-bg"]} />
        <GreenBanner
          leftText={kioskData.banner_title}
          rightText={kioskData.banner_paragraph}
        />
        <div ref={myRef} />
        <ContentsTwoColumn data={kioskData.features} />
        <div className={classes.spacer} />
        <div className={classes["section-title-wrapper"]}>
          <h1 className={classes["section-title"]}>
            {kioskData.solutions_title}
          </h1>
        </div>
        <ContentsTwoColumn data={kioskData.solutions} />
        <div className={classes.spacer} />
        <div className={classes["section-title-wrapper"]}>
          <h1 className={classes["section-title"]}>
            {kioskData.benefits_title}
          </h1>
        </div>
        <div className={classes.benefits}>
          {kioskData.benefits.map((benefit, index) => (
            <BenefitsCard key={index} benefit={benefit} />
          ))}
        </div>
        <div className={classes.spacer} />
        <div className={classes["section-title-wrapper"]}>
          <h1 className={classes["section-title"]}>
            {kioskData.options_title}
          </h1>
        </div>
        <ContentsTwoColumn data={kioskData.options} />
      </div>
      <div className={classes.spacer} />
      <CommonUseCases data="useCaseData" />
      <WaitingFor />
    </div>
  );
};

export default KioskSoftwareSolution;
